// @ai-generated 2026-07-21T03:45:01+00:00 by philipp.kammerer@synqony.com using claude-fable-5
import { useNotificationHub } from '@Contexts/notificationHub';
import { Badge, ContextMenu, useTranslate } from '@synqo/frontend-component-library';
import { IconBell } from '@tabler/icons-react';
import { NotificationHubDropdown } from './NotificationHubDropdown';
import styles from './NotificationHubButton.module.css';

export function NotificationHubButton() {
    const i18n = useTranslate('NotificationHub');
    const { unreadCount } = useNotificationHub();

    return (
        <div className={styles.wrapper}>
            <span id="notification_hub_label" className={styles.visuallyHidden}>
                {i18n('Benachrichtigungen')}
            </span>
            <ContextMenu
                icon={IconBell}
                name="notification_hub"
                labelId="notification_hub_label"
                position="bottom-end"
                variant="default"
                buttonSize="lg"
                className={styles.bellButton}
                tooltip={i18n('Benachrichtigungen')}
            >
                <NotificationHubDropdown />
            </ContextMenu>
            {unreadCount > 0 && (
                <span className={styles.badge}>
                    <Badge variant="danger" type="counter" size="xxs">
                        {unreadCount}
                    </Badge>
                </span>
            )}
        </div>
    );
}
